import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService, AccountGeneral } from '@dx/platform-components';
import { faUsers } from '@fortawesome/pro-light-svg-icons';
import { faMapMarkerAlt, faUserShield } from '@fortawesome/pro-solid-svg-icons';

import { AuthService } from '../../core/auth/auth.service';
import { NavigationService } from '../../core/services/navigation.service';

@Component({
  selector: 'dx-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  faMapMarkerAlt = faMapMarkerAlt;
  faUsers = faUsers;
  faUserShield = faUserShield;
  routeParams: ParamMap;
  account$: Observable<AccountGeneral>;
  hasError$ = new Subject<boolean>();
  error: any;

  constructor(private navigationService: NavigationService, private accountService: AccountService, public authService: AuthService) { }

  ngOnInit() {
    const route = this.navigationService.getRouteByComponent(AccountComponent);
    if (route) {
      route.paramMap.subscribe(params => {
        this.routeParams = params;
        this.load();
      });
    }
  }

  displayAddress(account: AccountGeneral): string {
    return this.accountService.displayAddress(account.primary);
  }

  private load() {
    this.account$ = this.accountService.getAccount(this.routeParams.get('accountNumber')).pipe(
      catchError(error => {
        this.error = error;
        this.hasError$.next(true);
        return throwError(error);
      })
    );
  }
}
